
import Vue, { PropType } from 'vue';
import { FilterItem } from '@/config/types';
import {
  FilterButtons,
  FilterInput,
  FilterList,
  LabelCount,
  Wrapper,
} from './styles';
import Button from '../Button/index.vue';
import Card from '../Card/index.vue';
import Checkbox from '../Checkbox/index.vue';
import Input from '../Input/index.vue';

export default Vue.extend({
  name: 'MenuFilter',
  components: {
    Button,
    Card,
    Checkbox,
    FilterButtons,
    FilterInput,
    FilterList,
    Input,
    LabelCount,
    Wrapper,
  },
  props: {
    options: Array as PropType<Array<FilterItem>>,
    visible: {
      type: Boolean,
      default: false,
    },
    selected: Array as PropType<Array<string>>,
  },
  data() {
    return {
      filteredOptions: this.options,
      hasInput: this.options && this.options.length > 2,
      inputSearch: '',
    };
  },
  methods: {
    clear() {
      this.filteredOptions = this.options;
      this.inputSearch = '';
      this.$emit('update:visible', false);
      this.selectAll(false);
      this.$emit('clear');
    },
    search(event: Event) {
      const enterEvent = event.type === 'keydown' && (event as KeyboardEvent).key === 'Enter';
      if (enterEvent) {
        this.inputSearch = (event.target as HTMLInputElement).value;
      }
      if (event.type === 'click' || enterEvent) {
        this.$emit('update:selected', []);

        this.filteredOptions = this.options.filter(
          (o) => o.value.toLowerCase().includes(this.inputSearch.toLowerCase()),
        );
      }
    },
    selectAll(checked: boolean) {
      const list = [] as Array<string>;
      (this.filteredOptions as Array<FilterItem>).forEach((o: FilterItem) => {
        const option = o;
        option.checked = checked;
        if (checked) {
          list.push(o.value);
        }
      });
      this.$emit('update:selected', list);
    },
    selectAllEvent(e: HTMLInputElement) {
      const { checked } = e;
      this.selectAll(checked);
    },
    selectItem(e: HTMLInputElement) {
      let list = this.selected;
      if (e.checked) {
        list.push(e.value);
      } else {
        list = list.filter((item) => item !== e.value);
      }
      this.$emit('update:selected', list);
      const option = (this.filteredOptions as Array<FilterItem>).find(
        (o: FilterItem) => o.value === e.value,
      ) as FilterItem;
      option.checked = e.checked;
    },
  },
  watch: {
    filteredOptions(curr) {
      this.hasInput = curr && curr.length > 1;
    },
  },
});
